import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import withIntl from "../../utils/withIntl";
import GetCurrency from "../../helper/GetCurrency";
import TextFieldForms from "../Forms/TextFieldForms";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles({
  textFieldContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 10,
  },
  label: { width: "100%", display: "flex" },
  input: { width: "100%" },
});

function MaxPriceSetting(props) {
  const classes = useStyles();

  return (
    <div className={classes.textFieldContainer}>
      <div className={classes.label}>
        <Typography style={{ fontWeight: 600, marginRight: 100 }} display={"inline"}>
          {props.intl.formatMessage({ id: "max_price" })}
        </Typography>
      </div>
      <div className={classes.input}>
        <TextFieldForms
          placeholder={`plus: ${props.article.plu} - ${GetCurrency() + " " + (props.article.price / 100).toFixed(2)}`}
          label={props.intl.formatMessage({ id: "arrangement_price" })}
          value={props.price}
          onChange={(event) => {
            let newValue = event.target.value;
            props.onChange(newValue);
          }}
          InputProps={
            props.price > 0 && {
              startAdornment: <InputAdornment position="start">{GetCurrency()}</InputAdornment>,
            }
          }
        />

        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
      </div>
    </div>
  );
}

export default withIntl(MaxPriceSetting);
